module.exports = __webpack_public_path__ + "static/media/file-pdf-regularc4ac2802.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/images/file-pdf-regular.svg
// module id = 1262
// module chunks = 0